import { Component, forwardRef, Inject, Input } from '@angular/core';
import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';

import { MessagesService }            from '../messages.service';
import { MessengerEmailOptionsModel } from './typings/messenger.email-options';
import { MessengerEmailParamsModel }  from './typings/messenger.email-params';
import { MessengerService }           from '../messenger/messenger.service';
import { TemplatedWordingService }    from '../../templates/templated-wording.service';
import { TemplateModel }              from '../../templates/typings/template';

@Component({
  selector   : 'messenger-email',
  template: require('./messenger.email.component.html')
})
export class MessengerEmailComponent {
  @BlockUI('messengerEmailBlock') block : NgBlockUI;

  @Input() email   : MessengerEmailParamsModel;
  @Input() options : MessengerEmailOptionsModel;

  constructor (
    public  activeModal            : NgbActiveModal,
    @Inject(forwardRef(() => MessagesService)) private messagesService        : MessagesService,
    @Inject(forwardRef(() => MessengerService))
    private messengerService       : MessengerService,
    @Inject(forwardRef(() => TemplatedWordingService)) private templatedWordingService: TemplatedWordingService,
  ) {}

  addTemplates () : void {
    this.templatedWordingService.addTemplate(this.options.templateKey)
    .then(( templates : Array<TemplateModel> ) => {
      templates.forEach(template => {
        /**
         * some emailing requires the body field
         * and other require message. We handle
         * this inconsistency here.
         */
        this.email.body = this.email.body
          ? `${ this.email.body }\n\n${ template.wording }`
          : template.wording;

        this.email.message = this.email.message
          ? `${ this.email.message }\n\n${ template.wording }`
          : template.wording;
      });
    });
  }

  send () : void {
    if ( this.options.modalOnly ) {
      this.activeModal.close(this.email);
    }
    else {
      this.block.start();

      this.messengerService.sendEmail(this.email, this.options)
      .then(() => this.activeModal.close(this.email))
      .catch(err => this.messagesService.error(err))
      .finally(() => this.block.stop());
    }
  }
}
